import { useStaticQuery, graphql } from 'gatsby'
import homeWorker from '../../workers/home/homeWorker'
import casinoWorker from '../../workers/casino/casinoWorker'
import { useContext } from 'react'
import { AuthContext } from '../../context/authProvider'
import { isFbUser } from '../../helpers/urlHelper'

export const useHomePageApiData = (customHome) => {
  const data = useStaticQuery(graphql`
    {
      homeApi {
        values {
          lang
          homeData {
            default
            home_data {
              acf_fc_layout
              # Related to Main Carousel
              header_title
              activeTo
              activeFrom
              banners {
                visibility_setting
                activeTo
                activeFrom
                add_cpf_field
                background_color
                header_tag
                header_text
                sub_text
                text_color
                cta_logged_out {
                  action_text
                  link
                  background_color
                  text_color
                }
                cta_logged_in {
                  action_text
                  link
                  background_color
                  text_color
                }
                background_image {
                  alt
                  title
                  url
                  sizes {
                    medium
                    medium_large
                    large
                  }
                }
                background_image_mobile {
                  alt
                  title
                  url
                  sizes {
                    medium
                    medium_large
                    large
                  }
                }
              }
              # Related to Product Menu
              products_list {
                text
                link
                activeTo
                activeFrom
                image {
                  url
                  alt
                }
                icon {
                  image {
                    url
                    alt
                  }
                }
              }
              # Related to Leagues Carousel
              link
              logos_list {
                activeTo
                activeFrom
                logo_link
                logo_text
                logo_image {
                  alt
                  url
                }
              }
              # Related to Games Carousel
              logged_out_description
              list_of_games {
                link
                tile_display
                background_mode
                games {
                  desktopSlug
                  mobileSlug
                  title
                  slug
                  providerName
                  providerCode
                  providerSlug
                  exclude_by_geo_location
                  disable_play_for_fun
                  coming_soon
                  maintenance_mode {
                    active_to
                    active_from
                  }
                  thumbnail {
                    alt
                    title
                    sizes {
                      medium
                      medium_large
                      large
                    }
                  }
                  thumbnail_tall {
                    alt
                    title
                    sizes {
                      medium
                      medium_large
                      large
                    }
                  }
                  game_tags
                }
              }
              # Shared between the Content Areas
              background_color
              cta {
                action_text
                link
              }
              cta_logged_out {
                action_text
                link
              }
              cta_logged_in {
                action_text
                link
              }
              # Related to Content Area 1
              content_area_1_big {
                color
                text
              }
              content_area_1_small {
                color
                text
              }
              image {
                alt
                title
                sizes {
                  medium
                  medium_large
                  large
                }
              }
              # Related to Content Area 2
              visibility_settings
              text_fields {
                content
                label
              }
            }
          }
        }
      }
    }
  `)
  const { accessCountry, isLoggedIn } = useContext(AuthContext)

  let filteredLayoutData = homeWorker?.filterData(
    data,
    customHome,
    accessCountry
  )

  if (isFbUser()) {
    filteredLayoutData = filteredLayoutData.filter(
      (item) =>
        item?.acf_fc_layout !== 'games_area' &&
        item?.acf_fc_layout !== 'logos_area' &&
        item?.acf_fc_layout !== 'products_area' &&
        item?.acf_fc_layout !== 'content_area_1' &&
        item?.acf_fc_layout !== 'banners'
    )
  }

  const layoutData = casinoWorker?.filterHomeGames(
    filteredLayoutData,
    accessCountry,
    isLoggedIn
  )

  return { layoutData }
}
